import { ElevenProof } from "../enums/elevenproof";

export const ELEVENPROOF_CONFIGS: Record<ElevenProof, { multipliers: number[]; divider: number }> = {
  bsn: { multipliers: [9, 8, 7, 6, 5, 4, 3, 2, -1], divider: 11 },
};
